<div class="uk-position-relative">
    <div style="margin-left: 20px; margin-top: -20px;" class="uk-position-absolute" *ngIf="session.role.ability === 'super-admin'">
        <a uk-slidenav-previous></a>
        <a class="uk-link-muted uk-text-uppercase uk-link-toggle" [routerLink]="['/user/society/list']">
            <span class="uk-link-heading">Liste des adhérents</span>
        </a>
    </div>

    <div class="uk-margin-medium-top tab">
        <ul class="uk-flex-center" uk-tab>
            <li [class.uk-active]="menu.active.tab === 'information'">
                <a [routerLink]="['/user/society/informations', id]">Informations</a>
            </li>
            <li [class.uk-active]="menu.active.tab === 'prices'" *ngIf="session.role.ability === 'super-admin'">
                <a [routerLink]="['/user/society/prices', id]">Tarifs</a>
            </li>
        </ul>
    </div>
</div>